// extracted by mini-css-extract-plugin
module.exports = {"main":"ProjectDetailPage_main__2FVM6","contentDetail":"ProjectDetailPage_contentDetail__1e7U1"};